import React, { useState } from "react";
import { Auth, API } from "aws-amplify";
import { Button, Spinner } from "react-bootstrap";

import "./Contest.css";

interface AcceptInviteButtonInput {
  contestId: string;
  setContestStatus(status: string): void;
}

export function AcceptInviteButton(acceptInviteInput: AcceptInviteButtonInput) {
  const [isSaving, setIsSaving] = useState(false);

  async function acceptInvite(_event: React.MouseEvent<HTMLElement>) {
    try {
      setIsSaving(true);
      const user = await Auth.currentAuthenticatedUser();
      const jwtToken = user.signInUserSession.idToken.jwtToken;
      const options = {
        headers: {
          Authorization: jwtToken,
        },
      };
      await API.post(
        "api",
        "contests/" + acceptInviteInput.contestId + "/accept",
        options
      );
      acceptInviteInput.setContestStatus("Accepted");
      setIsSaving(false);
    } catch (e) {
      alert(e);
      setIsSaving(false);
    }
  }

  return (
    <Button variant="primary" onClick={acceptInvite} disabled={isSaving}>
      {isSaving && (
        <Spinner
          as="span"
          animation="grow"
          size="sm"
          role="status"
          aria-hidden="true"
        />
      )}
      Accept
    </Button>
  );
}
